import React, { useEffect, useState } from "react";
import Logo from "./Logo";

/**
 * Fullscreen black splash showing the official Goldora logo stack.
 * Auto-dismisses after ~1.8s with fade-out. Shows on every page load (session-once)
 * so users get the brand moment from the image.
 */
export default function Splash() {
  const [visible, setVisible] = useState(() => {
    try {
      return sessionStorage.getItem("goldora_splash_seen") !== "1";
    } catch {
      return true;
    }
  });
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (!visible) return;
    const t1 = setTimeout(() => setFading(true), 1500);
    const t2 = setTimeout(() => {
      setVisible(false);
      try {
        sessionStorage.setItem("goldora_splash_seen", "1");
      } catch {}
    }, 2100);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] bg-black grid place-items-center transition-opacity duration-500 ${
        fading ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
      data-testid="splash-screen"
      aria-hidden={fading}
    >
      <div className="splash-anim">
        <Logo size={180} withWordmark stacked />
      </div>
      <style>{`
        .splash-anim {
          animation: splashRise 900ms cubic-bezier(0.2, 0.7, 0.2, 1) both;
          filter: drop-shadow(0 0 30px rgba(233, 185, 52, 0.15));
        }
        @keyframes splashRise {
          from { opacity: 0; transform: translateY(14px) scale(0.96); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </div>
  );
}
